<div class="bg-white dark:bg-gray-800 shadow-md rounded-lg px-3 py-2">
  <h3 class="text-lg font-medium text-gray-900 dark:text-white">
    Last Execution History
  </h3>
  <div class="overflow-x-auto mt-4 max-h-[600px]">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead
        class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
      >
        <tr>
          <th scope="col" class="px-2 py-3">Actions</th>
          <th scope="col" class="px-2 py-3">Id</th>
          <th scope="col" class="px-2 py-3">Report Name</th>
          <th scope="col" class="px-2 py-3">Schedule Type</th>
          <th scope="col" class="px-2 py-3">R. Time</th>
          <th scope="col" class="px-2 py-3">Last Status</th>
          <th scope="col" class="px-2 py-3">Duration (S)</th>
          <th scope="col" class="px-2 py-3">Last Exec.</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let execution of LastExecutionHistory"
          class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:shadow-lg transition-shadow duration-200"
        >
          <td class="px-2 py-2">
            <div class="flex space-x-2">
              <button (click)="showApiUrl(execution)" class="p-1 bg-blue-500 text-white rounded-md hover:bg-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>
              </button>
              <button
                (click)="forceRun(execution)"
                [disabled]="forceRunUsed"
                [title]="forceRunUsed ? 'Refresh ya usado en esta sesión. Cierra sesión para reiniciar.' : 'Forzar nueva ejecución del reporte'"
                [class]="forceRunUsed ? 'p-1 bg-gray-300 text-white rounded-md cursor-not-allowed' : 'p-1 bg-green-500 text-white rounded-md hover:bg-green-600'">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h5M20 20v-5h-5" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 9a9 9 0 0114.13-6.36M20 15a9 9 0 01-14.13 6.36" /></svg>
              </button>
              <button (click)="onRowClick(execution)" class="p-1 bg-gray-500 text-white rounded-md hover:bg-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>
              </button>
            </div>
          </td>
          <td
            class="px-2 py-2 font-medium text-gray-900 dark:text-white whitespace-nowrap"
          >
            {{ execution.id_report }}
          </td>
          <td
            class="px-2 py-2 font-medium text-gray-900 dark:text-white whitespace-nowrap"
          >
            {{
              execution.name.length > 40
                ? (execution.name | slice : 0 : 40) + ".."
                : execution.name
            }}
          </td>
          <td class="px-2 py-2">
            <span
              [ngClass]="{
                'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300':
                  execution.schedule_type === 'Daily',
                'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300':
                  execution.schedule_type === 'Hourly',
                'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300':
                  execution.schedule_type === 'High-Frequency',
                'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300':
                  execution.schedule_type === null ||
                  execution.schedule_type === ''
              }"
              class="text-xs font-medium mr-2 px-2.5 py-0.5 rounded"
              >{{ execution.schedule_type || "NOT FOUND" }}</span
            >
          </td>
          <td class="px-2 py-2">{{ execution.refresh_time | minutesToHoursConverter }}</td>
          <td class="px-2 py-2">
            <span
              [ngClass]="{
                'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300':
                  execution.last_execution_status === 'OK',
                'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300':
                  execution.last_execution_status === 'FAILED',
                'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300':
                  execution.last_execution_status === null ||
                  execution.last_execution_status === ''
              }"
              class="text-xs font-medium mr-2 px-2.5 py-0.5 rounded"
              >{{ execution.last_execution_status || "NOT FOUND" }}</span
            >
          </td>
          <td class="px-2 py-2">
            {{ execution.last_execution_duration_ms | miliSecondsConverter }}
          </td>
          <td class="px-2 py-2">
            {{ execution.last_execution_time | date : "HH:mm dd/MM/yyyy" }}
          </td>
        </tr>
        <tr *ngIf="!LastExecutionHistory || LastExecutionHistory.length === 0">
          <td
            colspan="4"
            class="px-2 py-2 text-center text-gray-500 dark:text-gray-400"
          >
            No data available
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
